import type { DiscoveredRouteModule } from '@/router/generator/types';

const InvitationView = () => import('@/views/InvitationView.vue');
const InvitationInvalidView = () => import('@/views/error-pages/InvitationInvalidView.vue');
const InvitationSuccessView = () => import('@/views/error-pages/AlreadyRegisteredView.vue');

export const NAME_INVITATION = 'Invitation';
export const NAME_INVITATION_SUCCESS = 'InvitationSuccess';
export const NAME_INVITATION_INVALID = 'InvitationInvalid';
export const PATH_INVITE = '/invite';
export const PATH_INVITATION_SUCCESS = '/invitation-success';
export const PATH_INVITATION_INVALID = '/invitation-invalid';

export const route: DiscoveredRouteModule = {
  id: 'root.invitations',
  scope: 'root',
  name: NAME_INVITATION,
  path: PATH_INVITE,
  component: InvitationView,
  meta: { requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true, skipRBAC: true, skipLoading: true }
};


